import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Button, Checkbox, Dialog, DialogTitle, FormControlLabel, FormGroup,
  Grid, Paper, Radio, TextField, FormLabel, RadioGroup, FormControl, Snackbar,
} from '@mui/material';
import useProjects from '../data/useProjects';
import useAuthContext from '../auth/useAuthContext';
import config from '../config';
import useUser from '../data/useUser';

function ProjectDialog({
  open, projects, handleClose, setCurrentProject,
}) {
  //  const { handleSubmit, control, reset, formState: { errors }, getValues, setValue } = useForm()
  const { user } = useAuthContext();
  const { addProject } = useProjects({ user });
  const [languages, setLanguages] = useState(config.languages);
  const [defaultLang, setDefaultLang] = useState();
  const [projectId, setProjectId] = useState('');
  const [description, setDescription] = useState('');
  const [defaultlangs, setDefaultlangs] = useState();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const { updateUser } = useUser({ user });
  const handleSubmit = (event) => {
    event.preventDefault();
    const existingProject = projects.find((p) => p.project === projectId);
    console.log('projects', projects);
    console.log('Existing project: ', existingProject);
    if (existingProject) {
      setShowSnackbar(true);
      return;
    }

    const enabledLanguages = languages.filter((language) => language.enabled);
    if (!defaultLang) {
      alert('Please select a default language');
      return;
    }
    addProject({
      project: projectId,
      description,
      languages: enabledLanguages,
      defaultLang,
    });
    setCurrentProject(projectId);
    updateUser({
      currentProject: projectId,
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        Create New Project
      </DialogTitle>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        message={`A project with the name "${projectId}" already exists`}
        sx={{ height: '100px' }}
        action={(
          <Button color='inherit' size='small' onClick={() => setShowSnackbar(false)}>
            Dismiss
          </Button>
  )}
      />
      <Box
        component='form'
        onSubmit={handleSubmit}
        sx={{
          width: '80%',
          m: 1,
        }}
      >
        <Paper elevation={0}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                sx={{ py: 1 }}
                size='small'
                label='Project Name'
                value={projectId}
                onChange={(e) => setProjectId(e.target.value)}
              />
              <TextField
                sx={{ py: 1 }}
                size='small'
                fullWidth
                label='Description'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Button variant='contained' type='submit'>
                Submit
              </Button>
            </Grid>
            <Grid item xs={4}>
              <FormGroup>
                {languages.map((language, index) => (
                  <FormControlLabel
                    key={language.name}
                    control={(
                      <Checkbox
                        checked={language.enabled}
                        onChange={(event) => {
                          const newLanguages = [...languages];
                          newLanguages[index].enabled = event.target.checked;
                          setLanguages(newLanguages);
                          setDefaultlangs(languages.filter((languag) => languag.enabled));
                        }}
                      />
      )}
                    label={`${language.code} (${language.name})`}
                  />
                ))}
              </FormGroup>
            </Grid>
            <Grid item xs={2}>
              <FormControl>
                <FormLabel id='demo-radio-buttons-group-label'>Default language</FormLabel>
                <RadioGroup
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue='female'
                  name='radio-buttons-group'
                >
                  {defaultlangs && defaultlangs.map((language) => (
                    <FormControlLabel
                      checked={defaultLang === language}
                      key={language}
                      value={language}
                      control={<Radio />}
                      onChange={() => setDefaultLang(language)}
                      label={`${language.code} (${language.name})`}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Dialog>
  );
}

ProjectDialog.propTypes = {
  open: PropTypes.bool,
  setCurrentProject: PropTypes.func,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.string,
      user: PropTypes.string,
      description: PropTypes.string,
      languages: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ),
  handleClose: PropTypes.func,
};

ProjectDialog.defaultProps = {
  open: false,
  projects: [],
  handleClose: () => {},
  setCurrentProject: () => {},
};

export default ProjectDialog;
